<script>
  import { createEventDispatcher } from 'svelte';
  import Button, { Label, Icon } from '@smui/button';
  import IconButton from '@smui/icon-button';

  const dispatch = createEventDispatcher();

  function batchSelectClickHandler(event) {
    dispatch('click', event);
  }
</script>

<IconButton
  id="mobile-batch-select-button"
  class="material-icons gigxr-icon batch-select-button filter-button__mobile"
  on:click={batchSelectClickHandler}
>
  filter_none
</IconButton>

<Button
  id="desktop-batch-select-button"
  class="batch-select-button filter-button__desktop"
  on:click={batchSelectClickHandler}
>
  <Icon class="material-icons gigxr-icon">filter_none</Icon>
  <Label>Actions</Label>
</Button>

<style>
  :global(.batch-select-button__desktop) {
    display: none;
  }

  @media (min-width: 1100px) {
    :global(.batch-select-button__mobile) {
      display: none !important;
    }

    :global(.batch-select-button__desktop) {
      color: var(--mdc-theme-secondary) !important;
      display: inline-block;
    }
  }
</style>
